<template>
  <!--
    같은 페이지내에선 두 개 트리 사용 불가
   -->
  <div id="treeContainer" class="tree-container" ></div>
</template>

<script setup>
import $ from 'jquery';
import 'jstree';
import {onMounted, ref, watch} from "vue";
import {useFolderStore} from "@/pinia";
const props = defineProps(['currentFolder', 'searchFolder', 'isChangeFolder'])
const emits = defineEmits(['set_currentFolder', 'rightSideClickEvent', 'set_isChangeFolder']);
const folderStore = useFolderStore();
const treeContainer = ref()

const creatTree = async ()=> {
  const treeContainer = $("#treeContainer");
  const treeData = await folderStore.getTree();
  let selectFolder;
  if(folderStore.isFolder(props.currentFolder)){
    selectFolder = await props.currentFolder
  }else{
    selectFolder = folderStore.getMinFolder();
    emits('set_currentFolder', folderStore.getMinFolder());
  }
  if(treeContainer.jstree(true)) {
    treeContainer.jstree('destroy');
  }
  treeContainer
      .on('ready.jstree', function (e, data) {
        $(this).off('ready.jstree').jstree('select_node', `folder-${selectFolder}`);
      })
      .on("select_node.jstree", (e,data)=>{
        if (data.event && data.event.which === 3) {
          e.preventDefault();
          treeContainer.jstree(true).deselect_node(data.node.id);
        }else{
          emits('set_currentFolder', folderStore.computedId(data.node.id));
        }
      })
      .bind("contextmenu", function (e, data) {
        e.preventDefault();
        const nodeId = treeContainer.jstree(true).get_node(e.target).id;
        emits('rightSideClickEvent', e,'folder',folderStore.computedId(nodeId)) ;
      })
      .jstree({
        core: {
          data: treeData
        },
        contextmenu: {
          items: function(node) {
            return {};
          }
        },
        plugins: ["contextmenu",'search']
      })
}

onMounted( ()=>{
  creatTree();
})
watch(()=> props.currentFolder,  (nv, ov) => {
  const tree = $("#treeContainer");
  tree.jstree(true).deselect_node(`folder-${ov}`);
  tree.jstree(true).select_node(`folder-${nv}`);
})
watch(()=>props.searchFolder , ()=>{
  const tree = $("#treeContainer");
  tree.jstree(true).search(props.searchFolder)
})
watch(()=>props.isChangeFolder , ()=>{
  if(props.isChangeFolder){
    creatTree()
    emits('set_isChangeFolder', false);
  }
})
</script>
<!-- scoped 쓰면 커스텀된 트리 디자인이 적용이 안됨.-->
<style >

.tree-container {
  padding: 10px;
}

aside.SNB {
  min-width: 15rem;
  background: #FFFFFF;
  height: 80vh;
  z-index: 1000;
  border-right: 1px solid #ddd;
}
aside.SNB .SNB_manager {
  position: relative;
}
aside.SNB .SNB_manager .SNB_manager_bottom_modal {
  position: absolute;
  background: white;
  min-width: 24rem;
  border-radius: 0.6rem;
  padding: 1.4rem 0;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  font: 1.4rem/2rem "Noto Sans KR";
  color: #333D54;
}
aside.SNB .SNB_manager .SNB_manager_bottom_modal button {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.6rem 0.6rem;
}
aside.SNB .SNB_manager .SNB_manager_bottom_modal button:hover, aside.SNB .SNB_manager .SNB_manager_bottom_modal button:active {
  background: #E0F0FF;
}
aside.SNB .SNB_manager .SNB_manager_bottom_modal button .icon {
  margin: 0 1rem 0 2rem;
}
aside.SNB .SNB_manager .SNB_manager_bottom_modal [data-divider=underline] {
  background: #DADFEA;
  width: 100%;
  height: 1px;
  margin: 0.4rem 0;
}
aside.SNB .SNB_search {
  margin-top: 10px;
}
aside.SNB .SNB_List .tree-container{
  font: 0.8rem/1rem "Noto Sans KR";
  color: #333D54;
  height: calc(100% - 12rem);
  overflow-x: hidden;
  overflow-y: auto;
}
aside.SNB .SNB_List .tree-container::-webkit-scrollbar {
  width: 8px; /* 스크롤바의 너비 */
  height: 10%; /* 스크롤바의 길이 */
}
aside.SNB .SNB_List .tree-container::-webkit-scrollbar-thumb {
  height: 10%; /* 스크롤바의 길이 */
  background: #accdf2; /* 스크롤바의 색상 */
  border-radius: 10px;
}
aside.SNB .SNB_List .tree-container::-webkit-scrollbar-track {
  background: transparent; /*스크롤바 뒷 배경 색상*/
}
aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-children {
  padding-top: 2.0rem;
  margin-left: 2rem;
}


aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node {
  padding: 0;
  min-height: 2.0rem;
  margin-left: 0;
  min-width: auto;
  position: relative;
  cursor: pointer;
  background-image:none; 
}

aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node .jstree-anchor {
  height: 1.5rem;
  width: inherit;
  line-height: 1.5rem;
  position: absolute;
  left: 1.8rem;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: none !important;
  border-radius: 5rem;
  background-color: none;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

/* 선택된 상태의 행의 스타일 */
.jstree-default .jstree-clicked > .jstree-anchor {
    z-index: -99; /* 배경색을 텍스트 뒤로 보냄 */
}

.jstree-default .jstree-anchor:hover, .jstree-default .jstree-anchor:focus {
  box-shadow: none !important;
  background-color: #C0E1FF;
  left: 2rem;
  content: "";
  display: block;
  height: 1.5rem;
}

aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node.jstree-leaf > .jstree-icon.jstree-ocl {
  display: none;
}
aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl {
  background: center/contain no-repeat url("/src/assets/icon_20_folderArrow.svg");
  width: 1.5rem;
  height: 1.5rem;
  transition: all 0.2s;
  position: absolute;
  top: 0.0rem;
  left: 0.5rem;
  transform-origin: center;
}
aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node.jstree-closed > .jstree-icon.jstree-ocl {
  transform: rotate(0);
}
aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node.jstree-open > .jstree-icon.jstree-ocl {
  transform: rotate(90deg);
}


aside.SNB .SNB_List#jstree .tree-container .jstree-container-ul .jstree-node .jstree-anchor .jstree-themeicon {
  background: center/contain no-repeat url("/src/assets/icon_20_folder.svg");
  min-width: 1.5rem;
  min-height: 1.5rem;
  margin-right: 0.5rem;
}

</style>